import React, {useContext} from "react";
import {Link} from "react-router-dom";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  achievementSection,
  roiCalculator,
  bigProjects,
  contactInfo
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewROI = roiCalculator.display;
  const viewGreeting = greeting.displayGreeting;
  const viewBigProjects = bigProjects.display;
  const viewContact = contactInfo.display;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <Link to="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <div
          className={isDark ? "dark-menu menu header-menu" : "menu header-menu"}
        >
          <div className="mobile-menu-intro">
            <span>AI systems • Automation • Data tools</span>
          </div>
          <ul className="header-nav-links">
            {viewGreeting && (
              <li>
                <Link to="/">Home</Link>
              </li>
            )}
            <li>
              <Link to="/about/">About</Link>
            </li>
            {viewSkills && (
              <li>
                <a href="/#skills">Build</a>
              </li>
            )}
            {viewExperience && (
              <li>
                <a href="/#proficiency">Value</a>
              </li>
            )}
            {viewBigProjects && (
              <li>
                <a href="/#projects">Work</a>
              </li>
            )}
            {viewROI && (
              <li>
                <a href="/#roi-calculator" title="ROI Calculator">
                  ROI
                </a>
              </li>
            )}
            {viewAchievement && (
              <li>
                <a href="/#achievements">Credentials</a>
              </li>
            )}
            {viewContact && (
              <li>
                <a href="/#contact" title="Start a project">
                  Contact
                </a>
              </li>
            )}
          </ul>

          <div className="header-nav-actions">
            <div className="header-nav-actions__theme">
              <ToggleSwitch />
            </div>
          </div>
        </div>
      </header>
    </Headroom>
  );
}

export default Header;
